import { useRef, KeyboardEvent } from 'react';
import classNames from 'classnames';
import { FieldRenderProps } from 'react-final-form';
import { FiX } from 'react-icons/fi';
import Button from 'components/Button';

import './KeywordsField.styles.scss';

type KeywordsInputFieldProps = FieldRenderProps<string[], HTMLElement> & {
  label?: string;
  className?: string;
  placeholder?: string;
};

const KeywordsInputField = ({
  input,
  meta,
  label,
  className,
  placeholder = 'Add keyword and press Enter...',
}: KeywordsInputFieldProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  // Ensure keywords is always an array
  const keywords: string[] = input.value || [];

  const handleKeyUp = (e: KeyboardEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value.trim();
    if (e.key === 'Enter') {
      e.preventDefault();
    }

    if (e.key === 'Enter' && value !== '') {
      // Only add if keyword doesn't already exist
      if (!keywords.includes(value)) {
        input.onChange([...keywords, value]);
      }
      e.currentTarget.value = ''; // Clear the input field after adding
    }
  };

  const handleRemove = (index: number) => {
    const updated = [...keywords];
    updated.splice(index, 1);
    input.onChange(updated);
  };

  return (
    <div className={classNames('input-field', className)}>
      {label && <label>{label}</label>}

      <div
        className="multi-search-filter"
        onClick={() => inputRef.current?.focus()}
      >
        {keywords.map((keyword, index) => (
          <div key={index} className="multi-search-item">
            <span>{keyword}</span>
            <Button
              variant="icon"
              onClick={() => handleRemove(index)}
              className="close-btn"
              type="button"
            >
              <FiX />
            </Button>
          </div>
        ))}
        <input
          type="text"
          ref={inputRef}
          onKeyUp={handleKeyUp}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && e.shiftKey === false) e.preventDefault();
          }}
          placeholder={placeholder}
        />
      </div>

      {meta.touched && meta.error && (
        <small className="error-text">{meta.error}</small>
      )}
    </div>
  );
};

export default KeywordsInputField;
